import z from 'zod';
import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { FaSearch } from 'react-icons/fa';
import { Button } from '../../atoms';
import { useAccentColors } from '../../hooks';
import { IconInput, LoadingBullets } from '../../molecules';
var valuesSchema = z.object({
    query: z.string().min(1)
});
export default function SearchForm(param) {
    var loading = param.loading, placeholder = param.placeholder, action = param.action, className = param.className, onSubmit = param.onSubmit;
    var accentStyle = useAccentColors([
        'colors-button-main-bg-base',
        '--colors-fg-base'
    ], [
        'colors-button-main-bg-hover',
        '--colors-fg-base'
    ]);
    var handleSubmit = function handleSubmit(event) {
        event.preventDefault();
        var raw = new FormData(event.currentTarget);
        var data = valuesSchema.safeParse(Object.fromEntries(raw.entries()));
        if (data.success && onSubmit) {
            onSubmit(data.data);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge('bg-red-700 p-6 rounded-2xl sm:rounded-full', className),
        style: accentStyle
    }, /*#__PURE__*/ React.createElement("form", {
        className: "grid gap-5 grid-cols-1 sm:grid-cols-[1fr_auto]",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(IconInput, {
        required: true,
        name: "query",
        icon: /*#__PURE__*/ React.createElement(FaSearch, null),
        disabled: loading,
        placeholder: placeholder
    }), /*#__PURE__*/ React.createElement(Button, {
        type: "no-icon",
        variant: "primary",
        htmlType: "submit",
        disabled: loading,
        className: "bg-button-main-bg-base/10 border-transparent w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-rows-1 items-center"
    }, /*#__PURE__*/ React.createElement("span", {
        className: twMerge('col-start-1 row-start-1 transition-all', loading && 'opacity-0')
    }, action.label), loading && /*#__PURE__*/ React.createElement("span", {
        className: "col-start-1 row-start-1"
    }, /*#__PURE__*/ React.createElement(LoadingBullets, null))))));
}

//# sourceMappingURL=SearchForm.js.map